module.exports = __webpack_public_path__ + "media/companies/Cathay-Capital-f767435f.png";